import { render, staticRenderFns } from "./EditVersionMailDialog.vue?vue&type=template&id=3b3ccd69&scoped=true"
import script from "./EditVersionMailDialog.vue?vue&type=script&lang=js"
export * from "./EditVersionMailDialog.vue?vue&type=script&lang=js"
import style0 from "./EditVersionMailDialog.vue?vue&type=style&index=0&id=3b3ccd69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3ccd69",
  null
  
)

export default component.exports